import { createSlice } from "@reduxjs/toolkit";
import { getCategoryProduct, submitCategoryProduct, deleteCategoryProduct } from "./Utils/categoryProductUtils";
import Swal from 'sweetalert2';

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "-id",
        "page": "",
    },
    categoryProducts: [],
    pagination: {},
    loading: false,
    error: null,
    currentCategoryProduct: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
    }
};

const categoryProductSlice = createSlice({
    name: "categoryProduct",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentCategoryProduct = { ...state.currentCategoryProduct, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentCategoryProduct = initialState.currentCategoryProduct;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters    : (state) => {
            state.filters = initialState.filters;
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getCategoryProduct
            .addCase(getCategoryProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCategoryProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.categoryProducts = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getCategoryProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle submitCategoryProduct
            .addCase(submitCategoryProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitCategoryProduct.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Kategori Berhasil Disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                // Kalau data baru, tambah ke daftar
                if (!state.categoryProducts.find(categoryProduct => categoryProduct.id === action.payload.id)) {
                    state.categoryProducts.push(action.payload);
                } else {
                    // Update data yang sudah ada
                    const index = state.categoryProducts.findIndex(categoryProduct => categoryProduct.id === action.payload.id);
                    state.categoryProducts[index] = action.payload;
                }
                state.currentCategoryProduct = initialState.currentCategoryProduct; // Reset form setelah submit
            })
            .addCase(submitCategoryProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle deleteCategoryProduct
            .addCase(deleteCategoryProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteCategoryProduct.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(deleteCategoryProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});
export const { setFormData, resetFormData, setFilters, resetFilters } = categoryProductSlice.actions;
export default categoryProductSlice.reducer;


